<template>
  <div class="content">
    <!-- 开户按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin: 0 0 20px 20px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
        >导出 Excel（数量/ {{ needList.length }}条）</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        :data="needList"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{background:'#e8effc', color:'#000'}"
      >
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column label="产品标题" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.productName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="链接" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.link}}</span>
          </template>
        </el-table-column>
        <el-table-column label="留言" width="150">
          <template slot-scope="scope">
            <span>{{scope.row.remarks}}</span>
          </template>
        </el-table-column>
        <el-table-column label="日期" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.createTime}}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteAdmin(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { selectNeed, deleteNeed } from "@/services/input";
export default {
  data() {
    return {
      downloadLoading: false,
      isrole: false, //禁用搜索框
      needList: [],
      supplierPhone: "",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: 1 },
        { name: "普通子账号权限", id: 2 }
      ],
      form: {},
      dialogFormVisible: false
    };
  },
  created() {
    //当用户为分销商时 赋值手机号 禁用筛选
    if (this.$store.state.supUser.roleId == 1) {
      this.supplierPhone = this.$store.state.supUser.supplierPhone;
      this.isrole = true;
    }
    // 查询用户登陆数据
    this.selece();
    // setVipcardByuserid(1,245401).then(res=>{console.log(res)})
  },
  methods: {
    // 根据供应商手机号查询
    selectBtn() {
      this.selece();
    },
    // 查询
    selece() {
      selectNeed().then(resp => {
        console.log(resp);
        this.loading = false;
        this.needList = resp;
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteNeed(row.id).then(resp => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.selece();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../vendor/Export2Excel").then(excel => {
        const tHeader = ["产品名", "链接","留言","日期"];
        const filterVal = ["productName","link","remarks", "createTime"];
        const list = this.needList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "用户需求表单下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    }
  }
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>